module.exports = __webpack_public_path__ + "static/media/White.6559ae95.svg";